<template>
  <sc-card title="Encontre aqui o seu aplicativo">
    <template slot="body">

      <div class="filter-name-section" v-if="this.appList.length > 0">
        <app-name-filter-field :appList="this.appList" />
      </div>

      <hr />

      <div class="filter-installation">

        <h1><b>{{ title.installationType.text }}</b></h1>
        <br />

        <sc-radio
          class="filter-installation-item"
          v-model="installationType"
          @input="() => applyFilter()"
          name="all"
          native-value="All">
          {{ title.installationType.all }}
        </sc-radio>

        <sc-radio
          class="filter-installation-item"
          v-model="installationType"
          @input="() => applyFilter()"
          name="installed"
          native-value="Installed">
          {{ title.installationType.installed }}
        </sc-radio>

        <sc-radio
          class="filter-installation-item"
          v-model="installationType"
          @input="() => applyFilter()"
          name="notinstalled"
          native-value="Notinstalled">
          {{ title.installationType.notInstalled }}
        </sc-radio>
      </div>

      <hr />

      <h1><b>{{ title.categoryType }}</b></h1>
      <br />

      <div v-for="category in this.getCategoryList()" :key="category">
        <sc-checkbox
          v-model="appCategory"
          :name="category"
          :native-value="category"
          @input="() => applyFilter()">
          {{ category }}
        </sc-checkbox>

      </div>

      <br />

      <sc-button theme="danger" @click="clearCategoryFilter" text="Limpar filtro" />

      <hr />

    </template>
  </sc-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ScCard, ScRadio, ScButton, ScCheckbox } from "@intelipost-js/secure-components";
import InstallationFilterButton from "./installation-filter-button";
import AppNameFilterField from "./app-name-filter-field/AppNameFilterField.vue";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-filter-card",

  data() {
    return {
      installationType: 'All',
      appCategory: [],
      title: {
        installationType: {
          text: 'Filtrar por instalação',
          all: 'Todos aplicativos',
          installed: 'Todos instalados',
          notInstalled: 'Todos não instalados'
        },
        categoryType: 'Filtrar por categoria'
      },
    }
  },

  computed: {
    ...mapState(["loading", "appList", "appsWithoutFilter"]),
  },

  methods: {
    ...mapActions(["getAppList", "setFilteredAppList"]),

    isTypeOfInstallationEqualInstalled(typeOfInstallation) {
      return 'Installed' === typeOfInstallation
    },

    isTypeOfInstallationEqualNotInstalled(typeOfInstallation) {
      return 'Notinstalled' === typeOfInstallation
    },

    isAppInstalled(app) {
      return app.status === 'INSTALLED' || (app.status === 'MANUALLY_INSTALLED'
        && (app.schemaBased && JSON.parse(app.schemaBased).version) === 'v2')
    },

    isAppNotInstalled(app) {
      return app.status === 'UNINSTALLED'
    },

    applyFilter() {

      let appListFilteredByCategories = []
      let appListFilteredByCategoriesAndInstallation = []

      if(this.appCategory.length > 0) {
        this.appCategory.map(category => {
          this.appsWithoutFilter.map(app => {
            if(category === app.category) {
              appListFilteredByCategories.push(app)
            }
          })
        })
      }else{
        this.appsWithoutFilter.map(app =>
          appListFilteredByCategories.push(app))
      }

      appListFilteredByCategories.map(app => {

        if(this.isTypeOfInstallationEqualInstalled(this.installationType)){

          if(this.isAppInstalled(app)){
            appListFilteredByCategoriesAndInstallation.push(app)
          }

        }

        else if(this.isTypeOfInstallationEqualNotInstalled(this.installationType)){

          if(this.isAppNotInstalled(app)){
            appListFilteredByCategoriesAndInstallation.push(app)
          }

        }

        else{
          appListFilteredByCategoriesAndInstallation.push(app)
        }

      })

      this.setFilteredAppList(appListFilteredByCategoriesAndInstallation)

    },

    clearCategoryFilter() {
      this.installationType = 'All'
      this.setFilteredAppList(this.appsWithoutFilter)
      this.appCategory = '';
    },

    getCategoryList() {

      const allCategories = this.appsWithoutFilter.map(app => app.category);

      const unique = allCategories.filter((value, index, self) => {
        return self.indexOf(value) === index
      })

      return unique;
    },

    filterAppByCategory(categoryChoosed) {

      const appsFilteredByCategory = this.appList.filter(app => {
        app.category === categoryChoosed
      })

      this.setFilteredAppList(appsFilteredByCategory)
    },

  },

  mounted() {
    this.installationType = 'All'
  },

  components: {
    InstallationFilterButton,
    AppNameFilterField,
    ScCard,
    ScRadio,
    ScButton,
    ScCheckbox
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.filter-name-section {
  width: 100%;
}

.filter-installation {
  display: flex;
  flex-direction: column;

  .filter-installation-item{
    margin: 0 0 0.5rem 0;
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-filter/NewAppFilter.vue?60b5210c